import { t } from 'i18next';
import { useCallback } from 'react';
import { useHandlers } from '../../../context/page-context';
import { downloadBlob } from '../../../utils/download';
import { usePriceListsApi } from './use-price-lists-api';

export function useExportPriceListCsv() {
  const { notificationHandler } = useHandlers();
  const { priceListsApi } = usePriceListsApi();

  return useCallback(
    async (slug: string) => {
      try {
        const data = await priceListsApi.priceList(slug).exportPricingCsv();

        const blob = new Blob([data], { type: 'text/csv' });
        const filename = `sparklayer-pricing-export-${slug}-${new Date().toJSON().replace('.', '-')}.csv`;
        downloadBlob(blob, filename);
      } catch {
        notificationHandler.error(t('price_list_builder.notifications.errors.download'));
      }
    },
    [priceListsApi, notificationHandler],
  );
}
